module.exports = __webpack_public_path__ + "img/letter-arrow-icon.27dc031a.svg";